module.exports = __webpack_public_path__ + "img/10.5b6ff822.png";